
  export const style={
    inpuStyle:{
      colorInput:"#040405"
    },
    url:{
      urlClient:"https://cmvaudiogroup.prd.appnoz.com.br/",
      urlClientYouseed:"https://admyouseed.bancosemear.com.br/"
    },
    fileUrl:{
      logo:"https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/primary_logo_client_cmv_audio_group.png",
      secondaryLogonLogo: "null",
    },
    variables:{
       customMenuItem: true,
       autoRegister: true,
       recaptchaVersion : "V2"
    },
    CurrencyName:{
      name:"Ponto/Pontos"
    },
    teamName:{
      name:"CMV Audio Group"
    },
    hasToken: false,
    hostHeader: "cmvaudiogroup"
  }
